import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { difference, isEmpty, cloneDeep, flatMap } from 'lodash';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, batch } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import BtnAdd from '../../Components/Utility/FilterAction/BtnAdd';
import BtnDelete from '../../Components/Utility/FilterAction/BtnDelete';
import SearchBar from '../../Components/Utility/FilterAction/SearchBar';
import Loader from '../../Components/Utility/Loader/Loader';
import DamListCard from '../../Components/Card/DamListCard/DamListCard';
import BtnSort from '../DevlopmentOrder/ProductInformation/BtnSort';
import DamFilter from './DamFilter';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import AssetGroupModal from '../../Components/ModalPopup/AssetGroupModal';
import { Page_Size, areArraysSimilar, damSortOpions } from '../../Components/helper';
import { fetchDamList, deleteDamFilesByIdAction, archivedDam, updateFileInFolderCollection } from './store/DAM.action';
import { fetchDamFolderGroupList } from '../Library/DamFolder/store/DamFolder.action';
import BtnSelectAll from '../../Components/Utility/FilterAction/BtnSelectAll';
import DamDragDropFoldersFiles from './DamDragDropFoldersFiles';
import AcrhivedFiles from './AcrhivedFiles';
import * as Action from './store/DAM.action';
import './DAM.css';
import { fetchColorListLibrary } from '../Library/ColorLibary/store/ColorLibrary.action';
import {
  getBrandDetails,
  getCategory1Details,
  getCategory2Details,
  getDamAttributeFreeText,
  getPCTypesDetails,
} from '../SystemMasters/Store/SystemMasters.action';
import { getAllGradings } from '../Library/Pom/Store/Pom.action';
import BinFiles from './binFiles';
import { useDAMModuleState } from './Provider/index';
import BtnBack from '../../Components/Utility/FilterAction/BtnBack';
import { toasterMsg } from '../../Components/Toaster/Toaster';

function DAM() {
  const dispatch = useDispatch();
  const [selectedFileId, setSelectedFileId] = useState(null);
  const [isOpenAssetModal, setIsOpenAssetModal] = useState(false);
  const [isSelectAll, setSelectAll] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const { Damstate, setDAMState, damAddEditAccess, damDeleteAccess } = useDAMModuleState([]);
  const { selectedIdArray, archivedList } = Damstate;
  const scrollableDivRef = useRef(null);
  const {
    damFolderData: { damFolderGroupList },
    UserDetails: {
      userInfo: { userId },
    },
    damModule: {
      filterValues: {
        pageIndex,
        pageSize,
        colourTheme,
        primaryColour,
        secondaryColour,
        folder,
        fileType,
        assetType,
        productType,
        brand,
        gradingGroups,
        category1,
        category2,
        category3,
        category4,
        dynamicDropdown,
        searchText,
        loading,
      },
      damList,
      totalCount,
    },
    uploader: { queueFiles },
  } = useSelector((reduxState) => reduxState);

  const [selectedBomLibraryGroupId, setBomId] = useState(null);
  const [timerId, setTimerId] = useState(null);

  const [state, setState] = useState({
    damList: [],
    hasMore: true,
    loading: true,
    totalRecords: null,
    searchLoaded: false,
    isArchivedModal: false,
    activeList: 'open',
    folderList: [],
    selectedFolders: [],
    archivedList: [],
    binList: [],
    dragging: false,
    filterSort: null,
  });

  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation('common');

  useEffect(() => {
    setState((inInfinitestate) => ({
      ...inInfinitestate,
      loading,
    }));
  }, [loading]);

  useEffect(() => {
    if (Array.isArray(damList)) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        damList,
      }));
    }
  }, [damList]);

  useEffect(() => {
    if (location?.state?.archived) {
      setState((prevData) => ({
        ...prevData,
        activeList: 'archived',
      }));
    }
  }, [location?.state?.archived]);

  useEffect(() => {
    if (totalCount > damList?.length) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: true,
      }));
    } else
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: false,
      }));
  }, [damList?.length, totalCount]);

  const buildParams = (data) => {
    const params = {
      pageIndex: data.pageIndex,
      pageSize: data.pageSize,
    };
    if (searchText) {
      params.searchText = searchText;
    }
    if (data.sortBy) {
      params.sortBy = data.sortBy;
    }
    if (data.sortOrder) {
      params.sortOrder = data.sortOrder;
    }
    params.isScrolled = data.isScrolled;
    return params;
  };

  const getDamListData = async (data, number) => {
    setState((toGetstate) => ({
      ...toGetstate,
      loading: true,
      ...data,
    }));

    const params = buildParams(data);
    await dispatch(fetchDamList(params));
    setState((inInfinitestate) => ({
      ...inInfinitestate,
      loading: false,
    }));
  };

  const handlePageNextInScroll = async () => {
    let index = pageIndex;
    index += 1;
    const params = {
      pageIndex: index,
      pageSize,
      searchText,
      totalRecords: totalCount,
      isScrolled: true,
    };
    if (state?.filterSort?.value) {
      params.sortOrder = state?.filterSort?.value?.sortOrder;
      params.sortBy = state?.filterSort?.value?.sortBy;
    }
    const obj = {
      pageIndex: index,
      pageSize,
    };
    await dispatch(Action.filterSortData(obj));
    await getDamListData(params);
  };

  useEffect(() => {
    const callFn = async () => {
      const localstorageFilter = JSON.parse(localStorage.getItem('damListFilter'));
      const params = {
        pageIndex,
        pageSize,
        loading: localstorageFilter?.loading,
        colourTheme: localstorageFilter?.colourTheme,
        primaryColour: localstorageFilter?.primaryColour,
        secondaryColour: localstorageFilter?.secondaryColour,
        folder: localstorageFilter?.folder,
        fileType: localstorageFilter?.fileType,
        assetType: localstorageFilter?.assetType,
        productType: localstorageFilter?.productType,
        brand: localstorageFilter?.brand,
        gradingGroups: localstorageFilter?.gradingGroups,
        category1: localstorageFilter?.category1,
        category2: localstorageFilter?.category2,
        category3: localstorageFilter?.category3,
        category4: localstorageFilter?.category4,
        dynamicDropdown: localstorageFilter?.dynamicDropdown,
      };
      setState((prevState) => ({ ...prevState, loading: true }));
      batch(async () => {
        const response = await dispatch(fetchDamList(params));
        if (response) setState((prevState) => ({ ...prevState, loading: false }));
      });
    };
    if (userId) callFn();
    return () => {
      const obj = {
        pageIndex: 1,
        searchText: '',
      };
      dispatch(Action.filterSortData(obj));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, userId]);

  useEffect(() => {
    if (damFolderGroupList) {
      setState((prev) => ({
        ...prev,
        folderList: damFolderGroupList,
      }));
    }
  }, [damFolderGroupList]);

  const handleSelectAll = () => {
    if (isSelectAll) {
      setDAMState((prev) => ({ ...prev, selectedIdArray: [] }));
    } else {
      const selectedItems = [...selectedIdArray];
      // eslint-disable-next-line no-restricted-syntax
      if (state.activeList === 'archived') {
        for (const item of archivedList) {
          const findItems = selectedItems.filter((val) => val === item._id);
          if (findItems.length === 0) {
            selectedItems.push(item._id);
          }
        }
      } else {
        for (const item of state.damList) {
          const findItems = selectedItems.filter((val) => val === item._id);
          if (findItems.length === 0) {
            selectedItems.push(item._id);
          }
        }
      }
      setDAMState((prev) => ({ ...prev, selectedIdArray: selectedItems }));
    }
    setSelectAll(!isSelectAll);
  };

  useEffect(() => {
    const callFn = async () => {
      batch(async () => {
        if (userId) {
          await dispatch(
            fetchColorListLibrary({
              loggedInUserId: userId,
            }),
          );
          await dispatch(
            getPCTypesDetails({
              loggedInUserId: userId,
              isActive: true,
              tier: 'Tier1',
            }),
          );
          await dispatch(
            getBrandDetails({
              loggedInUserId: userId,
              isActive: 1,
            }),
          );
          await dispatch(
            getAllGradings({
              isDropdawn: true,
              loggedInUserId: userId,
            }),
          );
          await dispatch(
            getCategory1Details({
              categoryType: 1,
              loggedInUserId: userId,
              isActive: true,
            }),
          );
          await dispatch(
            getCategory2Details({
              categoryType: 2,
              loggedInUserId: userId,
              isActive: true,
            }),
          );
          await dispatch(getDamAttributeFreeText({ type: 'dropdown' }));
        }
      });
    };
    if (!isEmpty(userId)) callFn();
  }, [dispatch, userId]);

  const refreshPage = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
      pageIndex: 1,
      damList: [],
      totalRecords: null,
      hasMore: true,
      searchText: '',
      searchLoaded: false,
    }));
    setDAMState((prev) => ({ ...prev, selectedIdArray: [] }));
    setBomId(null);
    setSelectAll(false);
    setIsOpenAssetModal(false);
    setSelectedFileId(null);
    const params = {
      pageIndex: 1,
      pageSize,
      damList: [],
      totalRecords: null,
      isSelectAll: false,
      selectedIdArray: [],
    };
    if (location?.state?.activeList === 'archived') {
      await dispatch(Action.fetchDamAcrhivedFiles(params));
    } else {
      await getDamListData(params);
    }
    setState((prev) => ({
      ...prev,
      loading: false,
    }));
  };

  const onSelectCheckBox = async (e, id) => {
    let selectedItems = [...selectedIdArray];
    const findItems = selectedItems.filter((item) => item === id);
    if (findItems.length > 0) {
      selectedItems = selectedItems.filter((item) => item !== id);
      setDAMState((prev) => ({ ...prev, selectedIdArray: selectedItems }));
    } else {
      setDAMState((prev) => ({ ...prev, selectedIdArray: [...selectedItems, id] }));
    }
  };

  const deleteDamFolderGroup = (id) => {
    setBomId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const deleteById = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    const params = {};
    if (selectedBomLibraryGroupId) {
      params.damId = [selectedBomLibraryGroupId];
    } else {
      params.damId = [...selectedIdArray];
    }
    const res = await dispatch(deleteDamFilesByIdAction(params, t));
    if (res) {
      setShowConfirmationPopup(!showConfirmationPopup);
      refreshPage();
    } else {
      setState((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  useEffect(() => {
    if (state.activeList === 'open' && state.damList.length > 0) {
      const stateIds = state.damList.map((item) => item._id);
      const selectedItems = [...selectedIdArray];
      const unSelectedItems = difference(stateIds, selectedItems);
      if (unSelectedItems.length > 0) {
        setSelectAll(false);
      } else {
        setSelectAll(true);
      }
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIdArray, state.activeList]);

  useEffect(() => {
    if (state.activeList === 'open' && state?.damList?.length > 0 && isSelectAll) {
      const selectedItems = [...selectedIdArray];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of state.damList) {
        const findItems = selectedItems.filter((val) => val === item._id);
        if (findItems.length === 0) {
          selectedItems.push(item._id);
        }
      }
      setDAMState((prev) => ({ ...prev, selectedIdArray: selectedItems }));
    }
  }, [state?.damList, isSelectAll]);

  useEffect(() => {
    if (state.activeList === 'archived' && state.archivedList.length > 0) {
      const stateIds = state.archivedList.map((item) => item._id);
      const selectedItems = [...selectedIdArray];
      const unSelectedItems = difference(stateIds, selectedItems);
      if (unSelectedItems.length > 0) {
        setSelectAll(false);
      } else {
        setSelectAll(true);
      }
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIdArray, state.activeList]);

  const handleSearch = async (e) => {
    const targetValue = e.target.value;
    setState((prev) => ({
      ...prev,
      searchLoaded: true,
    }));
    const obj = {
      searchText: targetValue,
      pageIndex: 1,
      pageSize: Page_Size,
      colourTheme,
      primaryColour,
      secondaryColour,
      folder,
      fileType,
      assetType,
      productType,
      brand,
      gradingGroups,
      category1,
      category2,
      category3,
      category4,
      dynamicDropdown,
      loading: true,
    };
    await dispatch(Action.filterSortData(obj));
  };

  const closeAcrhiveTrashDeleteModal = () => {
    setState((prevData) => ({
      ...prevData,
      isArchivedModal: false,
    }));
  };

  const closeAssetModal = () => {
    setIsOpenAssetModal(false);
  };

  const handleArchivedConfirmed = async () => {
    const obj = {
      archieveComment: state?.archivedComment,
      isArchived: state?.activeList === 'open',
    };

    if (selectedBomLibraryGroupId) {
      obj.damIds = [selectedBomLibraryGroupId];
    } else {
      obj.damIds = [...selectedIdArray];
    }

    const res = await dispatch(archivedDam(obj, t));
    if (res === 200) {
      closeAcrhiveTrashDeleteModal();
      refreshPage();
      setState((prevData) => ({
        ...prevData,
        archivedComment: '',
      }));
      if (state.activeList === 'archived') {
        setState((prevData) => ({
          ...prevData,
          activeList: 'archived',
        }));
      } else {
        setState((prevData) => ({
          ...prevData,
          activeList: 'open',
        }));
      }
      setDAMState((prev) => ({ ...prev, selectedIdArray: [] }));
    }
    const sortObj = {
      pageIndex: 1,
      pageSize,
    };
    await dispatch(Action.filterSortData(sortObj));
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        const params = {
          pageIndex,
          pageSize,
          searchText,
        };
        const obj = {
          pageIndex: 1,
          pageSize: Page_Size,
          searchText,
        };
        await dispatch(Action.filterSortData(obj));
        await dispatch(Action.fetchDamList(params));
        const afterApiCAllObj = {
          loading: false,
        };
        await dispatch(Action.filterSortData(afterApiCAllObj));
        setState((resetSearchstate) => ({
          ...resetSearchstate,
          searchLoaded: false,
        }));
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleArchiveCard = () => {
    setBomId(null);
    setState((prev) => ({
      ...prev,
      isArchivedModal: !state?.isArchivedModal,
    }));
  };

  const deleteCard = () => {
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const onFolderClick = () => {
    history.push('/digital-assets-management/folder', { archived: false, activeList: 'folder' });
    setState((prevData) => ({
      ...prevData,
      activeList: 'folder',
    }));
    const obj = {
      searchText: '',
    };
    dispatch(Action.filterSortData(obj));
  };

  const onOpenClick = async () => {
    history.push('/digital-assets-management', { activeList: 'open' });
    setState((prevData) => ({
      ...prevData,
      activeList: 'open',
    }));

    setDAMState((prev) => ({ ...prev, selectedIdArray: [] }));
    setSelectAll(false);

    const obj = {
      searchText: '',
    };
    await dispatch(Action.filterSortData(obj));

    const params = {
      pageIndex: 1,
      pageSize,
      damList: [],
      totalRecords: state.totalRecords,
      searchText,
      isScrolled: false,
    };
    await getDamListData(params);
  };

  const onArchivedAssetClick = async () => {
    history.push('/digital-assets-management', { activeList: 'archived' });
    setState((prevData) => ({
      ...prevData,
      activeList: 'archived',
    }));
    const obj = {
      pageIndex: 1,
      searchText: '',
    };
    setDAMState((prev) => ({ ...prev, selectedIdArray: [] }));
    dispatch(Action.filterSortData(obj));
    setSelectAll(false);
  };

  const onArchivedFolderClick = () => {
    history.push('/digital-assets-management/folder', { archived: true, activeList: 'archivedFolder' });
    setState((prevData) => ({
      ...prevData,
      activeList: 'archivedFolder',
    }));
    const obj = {
      searchText: '',
    };
    dispatch(Action.filterSortData(obj));
  };

  const handleArchive = (item) => {
    setBomId(item);
    setState((prev) => ({
      ...prev,
      isArchivedModal: !state?.isArchivedModal,
    }));
  };

  const handleFolderFilesChange = (choosedFolderFiles) => {
    history.push('/digital-assets-management/add', { choosedFolderFiles, isFolderDragDrop: true });
  };

  const handleAssetChange = (selectedGroups) => {
    setState((prev) => ({
      ...prev,
      selectedFolders: selectedGroups,
    }));
  };

  const onAssetSubmit = async () => {
    const data = {
      ids: selectedFileId !== null ? [selectedFileId] : selectedIdArray,
      folderList: state.selectedFolders || [],
    };
    const res = await dispatch(updateFileInFolderCollection(data, t));
    if (res.code === 200) {
      setBomId(null);
      setSelectAll(false);
      setIsOpenAssetModal(false);
      setSelectedFileId(null);
      setState((prev) => ({
        ...prev,
        selectedFolders: [],
      }));
      setDAMState((prev) => ({ ...prev, selectedIdArray: [] }));
    }
  };

  const onAddAssetModal = async (id) => {
    const filterDamList = id ? damList : damList?.filter((vls) => selectedIdArray?.includes(vls?._id));
    if (!id) {
      const arrayOfArrayAssignedTo = filterDamList?.map((vl) => vl.assignedTo);
      const productTypeAssignedArray = arrayOfArrayAssignedTo?.map((subArray) => subArray?.map((item) => item?.supplierType));
      const brandTypeAssignedArray = arrayOfArrayAssignedTo.map((subArray) => subArray.map((item) => item.brandId));
      const checkProductTypeSimilar = areArraysSimilar(productTypeAssignedArray);
      const checkBrandSimilar = areArraysSimilar(brandTypeAssignedArray);
      if (!checkBrandSimilar || !checkProductTypeSimilar) {
        toasterMsg('Please select similar product type and brand files', 'danger');
        return;
      }
    }
    const getTheAssignedTOArr = flatMap(filterDamList?.map((vl) => vl.assignedTo));

    const damSingleData = id ? filterDamList?.length > 0 && filterDamList.find((list) => list._id === id)?.assignedTo : getTheAssignedTOArr;
    const params = {
      isAllRecord: true,
    };
    params.productType = damSingleData?.map((data) => data?.supplierType) || [];
    params.brand = damSingleData?.map((data) => data?.brandId) || [];
    await dispatch(fetchDamFolderGroupList(params));
    setSelectedFileId(id);
    setIsOpenAssetModal(true);
  };

  const onDeleteClick = () => {
    setState((prev) => ({
      ...prev,
      selectedFolders: [],
    }));
  };

  const handleBinClick = () => {
    history.push('/digital-assets-management', { activeList: 'bin' });
    setState((prevData) => ({
      ...prevData,
      activeList: 'bin',
    }));
  };

  const onBackClick = async () => {
    history.push('/digital-assets-management', { activeList: 'open' });
    setState((prevData) => ({
      ...prevData,
      activeList: 'open',
    }));
  };

  const handleSortBy = async (val) => {
    setState((prevData) => ({
      ...prevData,
      filterSort: val
        ? {
            label: val?.label,
            value: {
              sortBy: val?.sortBy,
              sortOrder: val?.sortOrder,
            },
          }
        : null,
    }));
    const params = {
      pageIndex: 1,
      pageSize,
      searchText,
      isScrolled: false,
    };
    if (val?.sortBy) {
      params.sortBy = val.sortBy;
    }
    if (val?.sortOrder) {
      params.sortOrder = val.sortOrder;
    }
    await getDamListData(params);

    const obj = {
      pageIndex: 1,
      pageSize,
      searchText,
      isScrolled: false,
    };

    dispatch(Action.filterSortData(obj));
  };
  const disabledTillSameUplaoderUpdatedTheSameRecords = useMemo(() => {
    if (queueFiles && Object.keys(queueFiles)?.length > 0) {
      return Object.values(queueFiles)
        .map((obj) => obj._id)
        .filter((id) => id);
    }
    return [];
  }, [cloneDeep(queueFiles)]);

  useEffect(() => {
    if (location?.state?.activeList === undefined) {
      location.state = {
        ...location.state,
        activeList: 'open',
      };
    }
  }, [location?.state?.activeList]);

  const ondragExit = () => {
    const id = setTimeout(() => {
      setState((prevData) => ({
        ...prevData,
        dragging: false,
      }));
    }, 3000);
    setTimerId(id);
  };
  const handleDragOver = (isActive) => {
    setState((prevData) => ({
      ...prevData,
      dragging: isActive,
    }));
    if (timerId) {
      clearTimeout(timerId);
      setTimerId(null);
    }
    if (scrollableDivRef.current) window.scrollTo({ top: 0 });
  };

  const refreshProductDam = () => {
    if (selectedIdArray?.length > 30) {
      toasterMsg('please select 30 assets to update', 'danger');
      return;
    }
    // add new feature code
    const payload = {
      damIds: selectedIdArray,
    };
    dispatch(Action.updateProductDamRecord(payload, t));
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('DAM_MAIN_VIEW.LISTING_VIEW.TITLE')}</h4>
        </div>
        <div className="search-filter">
          {selectedIdArray?.length > 0 && (
            <span className="d-none d-md-inline-block  f-14 mr-4">
              {selectedIdArray?.length}
              {t('DAM_MAIN_VIEW.LISTING_VIEW.DAM_SELECTED')}
            </span>
          )}
          <SearchBar
            onSearch={(e) => {
              handleSearch(e);
            }}
            value={searchText}
            placeholder={t('DAM_MAIN_VIEW.LISTING_VIEW.SEARCH_DAM')}
          />
          {state.activeList === 'open' && (
            <>
              {damAddEditAccess && (
                <>
                  <Link className="cursor-pointer text-dark text-decoration-none" to="/digital-assets-management/add">
                    <BtnAdd addEditAccess onBtnClick={() => {}} />
                  </Link>
                  <button
                    type="button"
                    onClick={() => {
                      onAddAssetModal(null);
                    }}
                    disabled={!selectedIdArray?.length}
                    className="filter-btn filter-button_delete"
                    aria-label="Delete"
                    title="Add to folder"
                  >
                    <i className="icon-add_to_colour_group" />
                  </button>
                </>
              )}
              <BtnSort options={damSortOpions} onBtnClick={handleSortBy} val={state?.filterSort} />
            </>
          )}

          {state.activeList !== 'bin' && (
            <>
              <DamFilter />
              {damAddEditAccess && (
                <button
                  className="filter-btn"
                  type="button"
                  disabled={!selectedIdArray?.length}
                  title={location?.state?.activeList === 'open' ? t('DAM_MAIN_VIEW.LISTING_VIEW.ARCHIVE') : t('DAM_MAIN_VIEW.LISTING_VIEW.UNARCHIVE')}
                  onClick={() => handleArchiveCard()}
                  aria-label="archivedDam"
                >
                  <span className="icon-server" />
                </button>
              )}
              {state.activeList === 'open' && (
                <>
                  <Link className="cursor-pointer text-decoration-none text-dark" to="/digital-assets-management/history">
                    <button aria-label="Time" type="button" title="History" className="filter-btn">
                      <i className="icon-clock" />
                    </button>
                  </Link>
                  <button
                    className="filter-btn"
                    type="button"
                    disabled={!selectedIdArray?.length}
                    title="Bulk Update"
                    onClick={() => refreshProductDam()}
                    aria-label="bulkUpdate"
                  >
                    <span className="icon-update_new" />
                  </button>
                </>
              )}
              {state.activeList === 'archived' && damDeleteAccess && (
                <BtnDelete title="Delete" multiDelete={() => deleteCard()} isDisabled={!selectedIdArray?.length} />
              )}
              {damAddEditAccess && <BtnSelectAll handleSelectAll={handleSelectAll} isSelectAll={isSelectAll} />}
              {state.activeList === 'archived' && damAddEditAccess && (
                <button type="button" className="filter-btn filter-button_selectall btn-bin" onClick={() => handleBinClick()}>
                  {t('DAM_MAIN_VIEW.LISTING_VIEW.BIN')}
                </button>
              )}
            </>
          )}
          {state.activeList === 'bin' && <BtnBack backTriggered={onBackClick} />}
        </div>
      </div>
      <>
        {state.activeList !== 'bin' && (
          <Container fluid className="d-flex flex-wrap justify-content-end my-2">
            <button onClick={() => onOpenClick()} type="button" className={`btn my-1 my-md-0 btn-page-filter ${state?.activeList === 'open' && 'btn-active'}`}>
              {t('DAM_MAIN_VIEW.LISTING_VIEW.OPEN_ASSET')}
            </button>
            <button
              onClick={() => onFolderClick()}
              type="button"
              className={`btn my-1 my-md-0 btn-page-filter ${state?.activeList === 'folder' && 'btn-active'}`}
            >
              {t('DAM_MAIN_VIEW.LISTING_VIEW.OPEN_FOLDER')}
            </button>
            <button
              type="button"
              className={`btn my-1 my-md-0 btn-page-filter ${state?.activeList === 'archived' && 'btn-active'}`}
              onClick={() => onArchivedAssetClick()}
            >
              {t('DAM_MAIN_VIEW.LISTING_VIEW.ARCHIVED_ASSET')}
            </button>
            <button
              type="button"
              className={`btn my-1 my-md-0 btn-page-filter ${state?.activeList === 'archivedFolder' && 'btn-active'}`}
              onClick={() => onArchivedFolderClick()}
            >
              {t('DAM_MAIN_VIEW.LISTING_VIEW.ARCHIVED_FOLDER')}
            </button>
          </Container>
        )}
        <div>
          {state?.activeList === 'open' && state.damList !== null && (
            <InfiniteScroll
              dataLength={state?.damList?.length}
              next={handlePageNextInScroll}
              hasMore={state?.hasMore}
              loader={state.loading && <Loader />}
              scrollableTarget="scrollableDiv"
              className="fixed-col-container"
              ref={scrollableDivRef}
            >
              <div className="container-fluid my-3">
                <Row>
                  {state?.dragging && (
                    <Col md={3}>
                      <DamDragDropFoldersFiles handleFolderFilesChange={handleFolderFilesChange} handleDragOver={handleDragOver} />
                    </Col>
                  )}
                </Row>
                <div className="min-h-200" onDragEnter={() => handleDragOver(true)} onDragLeave={() => ondragExit()}>
                  <Row>
                    {state?.damList?.map((item, i) => (
                      <DamListCard
                        key={item?._id}
                        item={item}
                        index={i}
                        damAddEditAccess={damAddEditAccess}
                        onDelete={deleteDamFolderGroup}
                        onCheck={onSelectCheckBox}
                        selectedIds={selectedIdArray}
                        handleArchive={handleArchive}
                        folderList={state.folderList}
                        handleAssetChange={handleAssetChange}
                        selectedFolders={state.selectedFolders}
                        onAssetSubmit={onAssetSubmit}
                        onAddAssetModal={onAddAssetModal}
                        disabledTillSameUplaoderUpdatedTheSameRecords={disabledTillSameUplaoderUpdatedTheSameRecords}
                      />
                    ))}
                  </Row>
                  {!state.loading && state?.activeList === 'open' && state.damList.length === 0 && (
                    <p className="text-center">{t('DAM_MAIN_VIEW.LISTING_VIEW.NO_ASSETS_FOUND')}</p>
                  )}
                </div>
              </div>
            </InfiniteScroll>
          )}
          {state?.activeList === 'archived' && <AcrhivedFiles isSelectAll={isSelectAll} />}
          {state?.activeList === 'bin' && <BinFiles />}

          {showConfirmationPopup && (
            <ConfirmationPopup
              onOpen={showConfirmationPopup}
              onConfirm={deleteById}
              message={selectedBomLibraryGroupId?.length > 0 ? t('DAM_MAIN_VIEW.LISTING_VIEW.DAM_DELETE') : t('DAM_MAIN_VIEW.LISTING_VIEW.DAMS_DELETE')}
              title="Delete"
              toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
            />
          )}
          {state?.isArchivedModal && (
            <ConfirmationPopup
              onOpen={state?.isArchivedModal}
              fromSupplier
              onConfirm={() => handleArchivedConfirmed()}
              title={state?.activeList === 'open' ? t('DAM_MAIN_VIEW.LISTING_VIEW.ARCHIVED_DAM') : t('DAM_MAIN_VIEW.LISTING_VIEW.UNARCHIVE_DAM')}
              message={`${t('DAM_MAIN_VIEW.LISTING_VIEW.ARE_YOU_SURE_YOU_WANT_TO')} ${
                state?.activeList === 'open' ? t('DAM_MAIN_VIEW.LISTING_VIEW.ARCHIVE') : t('DAM_MAIN_VIEW.LISTING_VIEW.UNARCHIVE')
              } ${
                selectedBomLibraryGroupId?.length > 0 ? t('DAM_MAIN_VIEW.LISTING_VIEW.THE_SELECTED_DAM') : t('DAM_MAIN_VIEW.LISTING_VIEW.THE_SELECTED_DAMS')
              }`}
              toggle={closeAcrhiveTrashDeleteModal}
              isCommentOn
              comment={state?.archivedComment}
              commentText={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  archivedComment: e.target.value,
                }))
              }
            />
          )}
          {isOpenAssetModal && (
            <AssetGroupModal
              onOpen={isOpenAssetModal}
              options={state?.folderList}
              selectedFolders={state.selectedFolders}
              handleAssetChange={handleAssetChange}
              toggle={closeAssetModal}
              onConfirm={onAssetSubmit}
              onDeleteClick={onDeleteClick}
              selectedIds={selectedIdArray}
              selectedFileId={selectedFileId}
              selectedFilesData={state?.damList?.filter((vl) => selectedIdArray?.includes(vl._id))}
            />
          )}
        </div>
      </>
    </>
  );
}

export default DAM;
